module.exports = __webpack_public_path__ + "static/media/008.106ee87d.svg";